import type { ProfileData } from "shared/schema";
import type { Item } from "shelving";
import { createContext, useContext } from "react";
import { StateError } from "shelving";
import { MetadataContext } from "shared/react";
import { getProfilePath, getProfileTitle } from "shared/schema";
import { useItem } from "../util/db.js";

const PROFILE_CONTEXT = createContext<Item<ProfileData> | null>(null);

export function ProfileContext({ profile, children }: { profile: Item<ProfileData>; children: React.ReactNode }): React.ReactElement {
	return (
		<PROFILE_CONTEXT.Provider value={profile}>
			<MetadataContext title={getProfileTitle(profile)} path={getProfilePath(profile)}>
				{children}
			</MetadataContext>
		</PROFILE_CONTEXT.Provider>
	);
}

export function LoadProfileContext({ uid, children }: { uid: string; children: React.ReactNode }): React.ReactElement {
	const profile = useItem("profile", uid);
	return <ProfileContext profile={profile.data}>{children}</ProfileContext>;
}

export function useOptionalProfileContext(): Item<ProfileData> | null {
	return useContext(PROFILE_CONTEXT);
}

export function useProfileContext(): Item<ProfileData> {
	const profile = useContext(PROFILE_CONTEXT);
	if (!profile) throw new StateError("useProfileContext() must be used inside <ProfileContext>");
	return profile;
}
